import { render, staticRenderFns } from "./ClientAccount.vue?vue&type=template&id=4bdca452&scoped=true&lang=pug&"
import script from "./ClientAccount.vue?vue&type=script&lang=js&"
export * from "./ClientAccount.vue?vue&type=script&lang=js&"
import style0 from "./ClientAccount.vue?vue&type=style&index=0&id=4bdca452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdca452",
  null
  
)

export default component.exports